"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _InputField = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputField"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @deprecated use `react-intl`'s `FormattedMessage` and Orbit's `InputField` instead
 */
const Input = props => {
  const {
    value,
    validate,
    validationMode,
    onChange: onChangeValue,
    label,
    placeholder,
    help,
    error,
    ...rest
  } = props;
  const [isBlurred, setIsBlurred] = React.useState(false);
  const [val, setValue] = React.useState(value || "");
  const intl = (0, _reactIntl.useIntl)();
  const onChange = e => {
    const target = e.target;
    const v = target.value;
    setValue(v);
    if (onChangeValue != null) {
      onChangeValue(v);
    }
  };
  const getError = () => {
    // error can come from props
    if (error != null) {
      return intl.formatMessage(error);
    }
    if (validationMode !== "never") {
      // validate if input lost the focus (default) or it was requested by "validationMode" prop
      const runValidation = validationMode === "always" ? true : isBlurred;
      const validationError = runValidation && validate != null ? validate(val) : null;
      return validationError ? intl.formatMessage(validationError) : null;
    }

    // validationMode === "never" turns off any validation
    return null;
  };
  const onBlur = () => setIsBlurred(true);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
    ...rest,
    value: val,
    onChange: onChange,
    onBlur: onBlur,
    error: getError(),
    label: label,
    placeholder: placeholder,
    help: typeof help === "string" ? help : help
  });
};
var _default = Input;
exports.default = _default;